import { Address } from "@medusajs/medusa"
import React, { useState } from "react"

import { CreateAddressRequest } from "@lib/clients/nelo-api-client"

import NeloBackgroundContainer from "./nelo-background-container"
import AddressEntryForm from "../address-entry-form"

interface AddressContainerProps {
  address: Address | null
  submitAddress: (address: CreateAddressRequest) => void
}

const AddressContainer: React.FC<AddressContainerProps> = ({ address, submitAddress }) => {
  const [showAddressEntryForm, setShowAddressEntryForm] = useState<boolean>(false)

  return (
    <NeloBackgroundContainer
      title="Dirección de envío"
      subtitle={!showAddressEntryForm ? "Cambiar" : "Cancelar"}
      onSubtitleClick={() => {
        setShowAddressEntryForm(!showAddressEntryForm)
      }}
    >
      {" "}
      {showAddressEntryForm ? (
        <AddressEntryForm onSubmit={submitAddress} setShowAddressEntryForm={setShowAddressEntryForm} />
      ) : (
        <div className="relative flex items-center rounded-xl bg-white p-3 shadow-sm transition-colors sm:p-4">
          <div className="grow">
            <h3 className="font-nunito text-base font-bold text-nelo-blue sm:text-lg">
              {address?.first_name} {address?.last_name}
            </h3>
            <p className="font-nunito text-xs text-ui-fg-base sm:text-sm">
              {`${address?.address_1}${address?.address_2 ? `, Int: ${address?.address_2}` : ""}`}
            </p>
            <p className="font-nunito text-xs text-ui-fg-base sm:text-sm">{`${address?.province}, ${address?.city}`}</p>
            <p className="font-nunito text-xs text-ui-fg-base sm:text-sm">{`C.P. ${address?.postal_code}`}</p>
          </div>
        </div>
      )}
    </NeloBackgroundContainer>
  )
}

export default AddressContainer
